import './fonts';
import { DEFAULT_LOCALE, loadLocaleBundle, localeSettings } from '@alola/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { createI18nWith } from './i18n-runtime';
import { readStoredLocale } from './locale-preference';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

// The language last chosen in this browser (UX-003) is loaded with the default one and set on the
// document before the first render, so a refresh never flashes the other direction.
const preferred = readStoredLocale();
if (preferred) {
  document.documentElement.lang = preferred;
  document.documentElement.dir = localeSettings(preferred).direction;
}
const starting = [...new Set([DEFAULT_LOCALE, ...(preferred ? [preferred] : [])])];

// The starting languages are loaded before the first render; another one is loaded when chosen.
void Promise.all(starting.map((locale) => loadLocaleBundle(locale))).then((bundles) => {
  const i18n = createI18nWith(
    (key) => {
      // A missing key is a defect: make it loud in development. The CI key check keeps it out of builds.
      console.error(`[i18n] Missing translation key: ${key}`);
    },
    Object.fromEntries(starting.map((locale, index) => [locale, bundles[index]])),
  );
  createRoot(container).render(
    <StrictMode>
      <App i18n={i18n} />
    </StrictMode>,
  );
});
